import { Button, Grid, Group, NumberInput, Select } from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { useForm } from '@mantine/form';

import { transformDateFilter } from '@/shared/utils/helpers/datetime-format';
import { CustomCollapse, useAppSelector, selectCurrencies } from '@/shared';

import type { TGetPaymentsStatsParams } from '@/modules/payments/store/types';

type FormData = TGetPaymentsStatsParams;

type Props = {
  onSubmit: (data: TGetPaymentsStatsParams) => void;
  onReset: () => void;
};

export const StatsFilter = (props: Props) => {
  const { onSubmit, onReset } = props;
  const avalableCurrencies = useAppSelector(selectCurrencies);

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {},
  });

  const handleSubmit = (values: FormData) => {
    const newValues: TGetPaymentsStatsParams = {
      ...values,
      createdFrom: values.createdFrom ? transformDateFilter(values.createdFrom).dateFrom : undefined,
      createdTo: values.createdTo ? transformDateFilter(values.createdTo).dateTo : undefined,
    };

    onSubmit(newValues);
  };

  const handleReset = () => {
    form.reset();
    onReset();
  };

  return (
    <CustomCollapse title="Фильтр">
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Grid>
          <Grid.Col span={{ base: 12, md: 4 }}>
            {/* Первая секция */}
            <Group justify='space-between' grow>
              <DatePickerInput
                valueFormat="DD.MM.YYYY"
                label="Дата (от)"
                clearable
                key={form.key('createdFrom')}
                {...form.getInputProps('createdFrom')}
              />
              <DatePickerInput
                valueFormat="DD.MM.YYYY"
                label="Дата (до)"
                clearable
                key={form.key('createdTo')}
                {...form.getInputProps('createdTo')}
              />
            </Group>
            <Group justify='space-between' grow>
              <NumberInput
                label="ID магазина"
                key={form.key('shopId')}
                {...form.getInputProps('shopId')}
              />
              <NumberInput
                label="ID метода"
                key={form.key('methodId')}
                {...form.getInputProps('methodId')}
              />
            </Group>
          </Grid.Col>

          <Grid.Col span={{ base: 12, md: 4 }}>
            {/* Вторая секция */}
            <Select
              label="Валюта"
              clearable
              data={avalableCurrencies.map((currency) => ({ value: currency, label: currency }))}
              key={form.key('currency')}
              {...form.getInputProps('currency')}
            />
            <Group justify="flex-end" mt="25">
              <Button variant="outline" onClick={handleReset}>
                Сбросить
              </Button>
              <Button type="submit">
                Отправить
              </Button>
            </Group>
          </Grid.Col>
        </Grid>
      </form>
    </CustomCollapse>
  );
};
